import { render, staticRenderFns } from "./WebTabButton.vue?vue&type=template&id=3ea68da8&scoped=true"
import script from "./WebTabButton.vue?vue&type=script&lang=js"
export * from "./WebTabButton.vue?vue&type=script&lang=js"
import style0 from "./WebTabButton.vue?vue&type=style&index=0&id=3ea68da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea68da8",
  null
  
)

export default component.exports